import clsx from "clsx";

export const ImageCaption: React.FC<React.ComponentProps<"div">> = ({
  className,
  children,
  ...props
}) => {
  return (
    <div
      className={clsx(
        "absolute bottom-1/6 text-center text-yellow-300 translate-y-1/2 [text-shadow:1px_1px_0_black]",
        className,
      )}
      {...props}
    >
      {children}
    </div>
  );
};
